var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: _vm.cssClass },
    [
      _c(
        "no-ssr",
        [
          _c(
            "carousel",
            {
              attrs: {
                "per-page": 1,
                autoplay: true,
                "per-page-custom": _vm.perPageCustom,
                "pagination-enabled": false,
                "autoplay-hover-pause": true,
                loop: true,
                "scroll-per-page": false,
                "autoplay-timeout": 3000,
                speed: 1000
              }
            },
            _vm._l(_vm.manufacturers, function(slide, index) {
              return _c(
                "slide",
                { key: index },
                [
                  slide._source.logo !== ""
                    ? _c("router-link", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy:background-image",
                            value:
                              "https://atmedia.systemb2b.pl/uploads/pictures/brands/" +
                              slide._source.logo,
                            expression:
                              "`https://atmedia.systemb2b.pl/uploads/pictures/brands/` + slide._source.logo",
                            arg: "background-image"
                          }
                        ],
                        staticClass: "item no-underline",
                        attrs: {
                          to: _vm.localizedRoute(_vm.getBrandUrl(slide)),
                          title: slide._source.name
                        }
                      })
                    : _c(
                        "router-link",
                        {
                          staticClass: "item no-underline",
                          attrs: {
                            to: _vm.localizedRoute(_vm.getBrandUrl(slide))
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(slide._source.name) +
                              "\n        "
                          )
                        ]
                      )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }